<template>
  <div ref="input-search" :class="['input-search', classDropResult]">
    <div
      v-if="!isMobile"
      :class="['overlay', classDropResult]"
      @click="closeSearchBlock"
    />
    <div :class="['input-search__wrapper', classDropResult, {_filled: inputValue.length}]">
      <button
        v-if="isMobile"
        class="close-button"
        @click="closeSearchBlock"
      >
        <svg
          width="11" height="18"
          viewBox="0 0 11 18" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M1.29823 8.05477C0.900475 8.46157 0.900475 9.12111 1.29823 9.52791L8.42786 16.8196C8.82562 17.2264 9.47051 17.2264 9.86826 16.8196C10.266 16.4128 10.266 15.7532 9.86826 15.3464L3.45883 8.79134L9.86826 2.23624C10.266 1.82945 10.266 1.1699 9.86826 0.763105C9.47051 0.356309 8.82562 0.356309 8.42786 0.763105L1.29823 8.05477Z" fill="#333332"
            stroke="white" stroke-width="0.5"
            stroke-linecap="round" stroke-linejoin="round"
          />
        </svg>
      </button>
      <svg
        width="24" height="24"
        viewBox="0 0 24 24" fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="input-search__loop"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.9937 10.5194C15.9937 13.5648 13.5325 16.0336 10.4963 16.0336C7.46022 16.0336 4.99902 13.5648 4.99902 10.5194C4.99902 7.47396 7.46022 5.00517 10.4963 5.00517C13.5325 5.00517 15.9937 7.47396 15.9937 10.5194ZM15.0537 16.4899C13.7906 17.4614 12.2108 18.0388 10.4963 18.0388C6.35627 18.0388 3 14.6722 3 10.5194C3 6.36652 6.35627 3 10.4963 3C14.6364 3 17.9927 6.36652 17.9927 10.5194C17.9927 12.2293 17.4236 13.8058 16.4651 15.069L21 19.5426L19.6266 21L15.0537 16.4899Z"
          fill="#474747"
        />
      </svg>
      <input
        v-model="inputValue"
        type="text"
        class="input-search__input"
        placeholder="Поиск по сайту"
        @focus="onFocusInput"
        @keyup.enter="submitHandler"
      >
      <button
        v-if="isMobile && inputValue"
        class="clear-search-input"
        @click="clearInputValue"
      >
        <svg
          width="14" height="14"
          viewBox="0 0 14 14" fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M13.7662 0.233573C14.0776 0.545004 14.0776 1.04993 13.7662 1.36136L1.36112 13.7664C1.04969 14.0779 0.54476 14.0779 0.233329 13.7664C-0.0781018 13.455 -0.0781018 12.9501 0.233329 12.6386L12.6384 0.233573C12.9498 -0.0778577 13.4548 -0.0778577 13.7662 0.233573Z" fill="#333332"
          />
          <path
            fill-rule="evenodd" clip-rule="evenodd"
            d="M0.233329 0.233573C0.54476 -0.0778577 1.04969 -0.0778577 1.36112 0.233573L13.7662 12.6386C14.0776 12.9501 14.0776 13.455 13.7662 13.7664C13.4548 14.0779 12.9498 14.0779 12.6384 13.7664L0.233329 1.36136C-0.0781018 1.04993 -0.0781018 0.545004 0.233329 0.233573Z" fill="#333332"
          />
        </svg>
      </button>
    </div>
    <drop-search-result
      v-if="isShowDropResult"
      :mod="classDropResult"
      :data="data"
      :search-string="inputValue"
      :is-mobile="isMobile"
      :new-local-storage-history="newLocalStorageHistory"
      @setQuery="onSetQuery"
    />
  </div>
</template>

<script>
import clickOutside from 'click-outside';
import debounce from '../../../assets/js/helpers/debounce';
import api from './api/index';

import DropSearchResult from './components/DropSearchResult.vue';

export default {
  name: 'input-search',

  components: {
    DropSearchResult,
  },

  data() {
    return {
      inputValue: '',
      data: {},
      isShowDropResult: false,
      unbind: null,
      width: null,
      newLocalStorageHistory: '',
    };
  },

  computed: {
    classDropResult() {
      return this.isShowDropResult ? '_open' : '';
    },
    cssVars() {
      return {
        // eslint-disable-next-line
        '--background-image': "url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDEyIDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjUyNzM0NCA0LjAyNzdMMS45NDIzNiAyLjUwMTFMNS4wMDA3NiA1LjUzMzYxTDEwLjExMjIgNC4xODk2N2UtMDdMMTEuNTI3MiAxLjUyNjYxTDUuMDAwNzYgOC41ODY4OEwwLjUyNzM0NCA0LjAyNzdaIiBmaWxsPSIjNDc0NzQ3Ii8+Cjwvc3ZnPgo=')"
      };
    },
    isMobile() {
      return this.width < 951;
    },
  },

  watch: {
    inputValue(newValue) {
      if (newValue.length >= 2) {
        this.debouncedGetAnswer();
      }
    },
  },

  created() {
    this.debouncedGetAnswer = debounce(this.getResult, 300);
  },

  mounted() {
    this.initResize();
    this.onClickInputSearch();

    if (window.location.pathname === '/search/') this.inputValue = this.getQueryParam();
  },

  beforeOnmount() {
    this.unbind();
    window.removeEventListener('resize', this.resizeHandler);
  },

  methods: {
    async getResult() {
      try {
        const { data } = await api.getAutoComplete(this.inputValue);
        this.data = data.data;
      } catch (e) {
        // eslint-disable-next-line
        console.error(e);
      }
    },

    onFocusInput() {
      const bodyElem = document.querySelector('body');
      if (bodyElem) bodyElem.style.overflow = 'hidden';
      this.isShowDropResult = true;
      this.getResult();
    },

    onClickInputSearch() {
      this.unbind = clickOutside(this.$refs['input-search'], () => {
        this.closeSearchBlock();
      });
    },

    closeSearchBlock() {
      const bodyElem = document.querySelector('body');
      if (bodyElem) bodyElem.style.overflow = 'auto';
      this.isShowDropResult = false;
    },

    onSetQuery(query) {
      this.inputValue = query;
    },

    submitHandler() {
      this.newLocalStorageHistory = this.inputValue;
      this.$nextTick(() => {
        this.newLocalStorageHistory = '';
      });
      window.location.href = `${window.location.origin}/search/?query=${this.inputValue}`;
    },

    resizeHandler() {
      this.width = window.innerWidth;
    },

    initResize() {
      this.resizeHandler();
      window.addEventListener('resize', this.resizeHandler);
    },

    clearInputValue() {
      this.inputValue = '';
    },

    getQueryParam() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get('query');
    },
  },
};
</script>

<style lang="scss" scoped>
.input-search {
  position: relative;
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  margin-right: 30px;

  &._open {
    border-radius: 4px;

    @media (min-width: 950px) and (max-width: 1279px) {
      position: absolute;
      left: 430px;
      z-index: 102;
      width: 410px;
    }

    @media (min-width: 950px) and (max-width: 1024px) {
      left: 400px;
    }
  }

  @media (max-width: 950px) {
    width: calc(100% - 40px);
    height: 36px;
    margin: 0;
  }

  @media (max-width: 599px) {
    justify-content: flex-end;
  }

  .overlay {
    display: none;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 101;
    background-color: rgba(0, 0, 0, .3);

    &._open {
      display: block;
    }
  }

  &__wrapper {
    position: relative;
    width: 100%;
    height: 44px;
    z-index: 103;
    @media (max-width: 950px) {
      display: flex;
      column-gap: 10px;
    }

    .close-button {
      display: none;
      background-color: rgba(0, 0, 0, 0);
      opacity: .3;
    }

    &._dropped {
      .drop-search-header__results {
        visibility: visible;
        opacity: 1;
      }
    }

    &._open {
      .close-button {
        display: block;
      }

      .input-search__loop {
        display: none;
      }

      .input-search__input {
        padding-left: 19px;
      }

      &:after {
        position: absolute;
        content: '';
        margin-left: auto;
        margin-right: auto;
        left: 0;
        right: 0;
        bottom: 0;
        width: 95%;
        height: 1px;
        background: #e5e5e5;
        @media (max-width: 950px) {
          display: none;
        }
      }

      .input-search__input {
        @media (min-width: 951px) {
          border-color: transparent
        }
      }
    }

    &._filled {
      .clear-search-input {
        display: block;
        position: absolute;
        top: 15px;
        right: 20px;
        background-color: rgba(0, 0, 0, 0);
        opacity: .3;
      }
    }
  }

  &__loop {
    position: absolute;
    top: 10px;
    left: 10px;
  }

  &__item {
    cursor: pointer;
    height: 20px;
    display: inline-flex;
    align-items: center;
    font-size: 17px;
    letter-spacing: 0.04em;
    width: 100%;

    @media (any-hover: hover) {
      &:hover {
        p {
          opacity: 1;
        }
      }
    }

    svg {
      width: 19px;
      height: 19px;
      flex-shrink: 0;
      margin-right: 10px;
    }

    p {
      opacity: 0.6;
      transition: opacity 0.5s;
    }
  }

  &__input {
    width: 100%;
    height: 44px;
    padding: 13px 13px 13px 42px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-size: 17px;
    font-weight: 400;
    letter-spacing: 0.04em;
    opacity: 0.6;
    transition: opacity 0.5s;
    background: var(--background-image)
      no-repeat 13px;
    @media (max-width: 950px) {
      padding-right: 45px;
    }

    &:hover,
    &:focus {
      opacity: 1;
    }
  }

  .clear-search-input {
    display: none;
  }

  &__show-more {
    display: inline-block;
    margin: 20px 0 0 0;
    font-size: 19px;
    color: #e30613;
    position: relative;
  }
}
</style>
